<template>
  <div class="inline-block">
    <button class="btn btn-sm btn-alert" @click="openModal">Upload</button>
    <modal
      :openModal="isOpenModal"
      :closeModalFunction="exitModal"
      :closeModalonClickOutSide="true"
    >
      <section class="section-1">
        <i class="fa fa-upload modal-icon" aria-hidden="true"></i>
      </section>
      <section class="section-2">
        <p>{{ "Csv format - " + printCsvFormat }}</p>
        <label
          for="custom-modal_csv-file-upload"
          class="custom-modal_csv-file-upload-label"
          >Upload csv file</label
        >
        <input
          id="custom-modal_csv-file-upload"
          type="file"
          accept=".csv"
          placeholder="import csv"
          class="custom-modal_csv-file-upload-input"
          @change="uploadFile"
        />
        <div class="custom-modal_preview">
          <p>
            {{ fileName ? fileName : "No files currently selected for upload" }}
          </p>
          <Loading v-if="loading" />
        </div>
      </section>
      <section class="section-3">
        <button class="btn btn-sm btn-alert" @click="exitModal">Cancel</button>
        <button class="btn btn-sm btn-success" @click="onSave">Save</button>
      </section>
    </modal>
  </div>
</template>

<script>
import Modal from "./Modal.vue";
import Loading from "./Loading.vue";
export default {
	name: "UploadModal",
	props: {
		isValidCsvHeaders: {
			type: Function,
			default: function() {
				return true;
			}
		},
		uploadEntireFile: {
			type: Function,
			default: async function(data) {
				console.log(data);
			}
		},
		uploadDataPerLine: {
			type: Function,
			default: async function(data) {
				console.log(data);
			}
		},
		canUploadAnEntireFile: {
			type: Boolean,
			default: false
		},
		csvFormat: {
			type: Array,
			default: () => ["any", "any"]
		}
	},
	computed: {
		printCsvFormat: function() {
			return this.csvFormat.join(",");
		}
	},
	components: {Modal, Loading},
	data: () => ({
		fileName: "",
		isOpenModal: false,
		csvFile: "",
		loading: false
	}),
	created() {
		let $injector = this.$root.angularInjector;
		this.SwalService = $injector.get("SwalService");
	},
	methods: {
		uploadFile(event) {
			this.toggleLoading();
			const file = event.target.files[0];
			if (/^.+\.(xlsx|xls|csv)$/.test(file.name)) {
				this.fileName = file.name;

				const fileReader = (f) => {
					const reader = new FileReader();
					return new Promise((resolve, reject) => {
						reader.readAsText(f, "base64");
						reader.onload = () => {
							resolve(reader.result);
						};
						reader.onerror = reject;
					});
				};
				fileReader(file).then((data) => {
					this.csvFile = data;
					this.toggleLoading();
				});
			}
			else {
				this.fileName = "Invalid file type";
				this.toggleLoading();
			}
		},
		exitModal() {
			this.fileName = "";
			this.csvFile = "";
			this.isOpenModal = false;
		},
		openModal() {
			this.isOpenModal = true;
		},
		async onSave() {
			this.toggleLoading();
			if (!this.csvFile) {
				this.swal("Error", "warning", "The file is empty");
				this.toggleLoading();
				return;
			}
			let csvData = this.transformCsvStringToArrayOfArrays(this.csvFile);
			if (!this.isValidCsvHeaders(csvData[0])) {
				this.swal(
					"Error",
					"warning",
					"There is a problem with the csv file, the titles may not match"
				);
				this.toggleLoading();
				return;
			}
			let title = "Success";
			let type = "success";
			let text = "we upload the file";
			try {
				if (this.canUploadAnEntireFile) {
					await this.uploadEntireFile(this.csvFile);
				}
				else {
					const csvFixData
            = this.changeCsvArrayOfArraysToArryOfObjects(csvData);
					let result = await this.uploadDataPerLine(csvFixData);
					result = this.createMultiErrorMessage(result);
					if (result) {
						throw new Error(result);
					}
				}
			}
			catch (e) {
				title = "Error";
				type = "warning";
				text = e.message || "There is a problem with the csv file lines";
			}
			finally {
				this.swal(title, type, text);
				this.$emit("uploadfinish", {type, text});
				this.toggleLoading();
			}
		},
		toggleLoading() {
			this.loading = !this.loading;
		},
		transformCsvStringToArrayOfArrays(csvString, strDelimiter) {
			strDelimiter = strDelimiter || ",";
			// Create a regular expression to parse the CSV values.
			var objPattern = new RegExp(
				// Delimiters.
				"(\\"
          + strDelimiter
          + "|\\r?\\n|\\r|^)"
          // Quoted fields.
          + "(?:\"([^\"]*(?:\"\"[^\"]*)*)\"|"
          // Standard fields.
          + "([^\"\\"
          + strDelimiter
          + "\\r\\n]*))",
				// Flags
				"gi"
			);
			var arrData = [[]];
			var arrMatches = null;
			while ((arrMatches = objPattern.exec(csvString))) {
				var strMatchedDelimiter = arrMatches[1];
				if (
					strMatchedDelimiter.length
          && strMatchedDelimiter !== strDelimiter
				) {
					arrData.push([]);
				}
				var strMatchedValue;
				if (arrMatches[2]) {
					strMatchedValue = arrMatches[2].replace(new RegExp("\"\"", "g"), "\"");
				}
				else {
					strMatchedValue = arrMatches[3];
				}
				arrData[arrData.length - 1].push(strMatchedValue);
			}
			arrData = arrData.filter((arr) => {
				return !(arr.length === 1 && arr[0] === "");
			});
			return arrData;
		},
		changeCsvArrayOfArraysToArryOfObjects(csvAsArrayOfArrays) {
			const headers = csvAsArrayOfArrays.shift();
			return csvAsArrayOfArrays.reduce((startValue, line) => {
				const lineObj = line.reduce((startObj, currentVal, index) => {
					const header = headers[index];
					startObj[header] = currentVal;
					return startObj;
				}, {});
				startValue.push(lineObj);
				return startValue;
			}, []);
		},
		swal(title, type, text) {
			this.SwalService.popup({title, type, text});
		},
		createMultiErrorMessage(array) {
			return array.reduce((startvalue, current) => {
				if (current.error) {
					startvalue += current.message + "\n";
				}
				return startvalue;
			}, "");
		}
	}
};
</script>
<style lang="scss" scoped>
.inline-block {
  display: inline-block;
}
</style>